var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oa-check-container" },
    [
      _c(
        "div",
        { staticClass: "header-goback", on: { click: _vm.goBack } },
        [
          _c("svg-icon", { attrs: { "icon-class": "goback" } }),
          _vm._v(" 返回 ")
        ],
        1
      ),
      _c("header", [_vm._v(_vm._s(_vm.probeTitle))]),
      _c("p", [_vm._v(_vm._s(_vm.probeText))]),
      _vm.probeType !== "todoConfirm"
        ? [
            _c(
              "section",
              [
                _c(
                  "el-form",
                  {
                    ref: "loginForm",
                    staticClass: "login-form",
                    attrs: { model: _vm.loginForm, rules: _vm.rules },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v("对接同事手机号："),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.staffQueryBusy,
                            expression: "staffQueryBusy"
                          }
                        ],
                        staticClass: "el-icon-loading"
                      })
                    ]),
                    _c(
                      "div",
                      {
                        class: [
                          "select-code",
                          { "phone-active": _vm.phoneActive }
                        ]
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              "popper-append-to-body": false,
                              disabled: _vm.disabledPhoneInput
                            },
                            on: {
                              change: function($event) {
                                _vm.loginForm.phone = ""
                              }
                            },
                            model: {
                              value: _vm.selectCode,
                              callback: function($$v) {
                                _vm.selectCode = $$v
                              },
                              expression: "selectCode"
                            }
                          },
                          _vm._l(_vm.areaCodeList, function(item) {
                            return _c(
                              "el-option",
                              {
                                key: item.countryCode,
                                attrs: { value: item.countryCode }
                              },
                              [
                                _c("span", { staticClass: "country" }, [
                                  _vm._v(_vm._s(item.country))
                                ]),
                                _c(
                                  "span",
                                  { staticStyle: { float: "right" } },
                                  [_vm._v(_vm._s(item.countryCode))]
                                )
                              ]
                            )
                          }),
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "phone" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "text",
                                placeholder: "请输入龙湖对接同事工作手机号",
                                autocomplete: "off",
                                maxlength: "11",
                                clearable: "",
                                spellcheck: "false",
                                disabled: _vm.disabledPhoneInput
                              },
                              on: {
                                focus: function($event) {
                                  _vm.phoneActive = true
                                },
                                blur: function($event) {
                                  _vm.phoneActive = false
                                }
                              },
                              model: {
                                value: _vm.loginForm.phone,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.loginForm,
                                    "phone",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "loginForm.phone"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "input-item" },
                  [
                    _c("font", [_vm._v("对接同事姓名：")]),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.staffUserName,
                            expression: "staffUserName"
                          }
                        ]
                      },
                      [_vm._v(_vm._s(_vm.staffUserName))]
                    ),
                    _c("span", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.staffUserName && _vm.staffQueryBusy,
                          expression: "!staffUserName && staffQueryBusy"
                        }
                      ]
                    }),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.staffUserName && !_vm.staffQueryBusy,
                            expression: "!staffUserName && !staffQueryBusy"
                          }
                        ],
                        staticClass: "holder"
                      },
                      [_vm._v("根据手机号自动显示")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "footer",
              [
                _vm.probeType === "warn"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "plain" },
                        on: { click: _vm.doNextTime }
                      },
                      [_vm._v("下次处理")]
                    )
                  : _vm._e(),
                _vm.probeType === "force"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "plain" },
                        on: {
                          click: function($event) {
                            return _vm.goBack("force")
                          }
                        }
                      },
                      [_vm._v("暂不登录")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.sendProbeLoading,
                      disabled: _vm.disabledApplyBtn
                    },
                    on: { click: _vm.sendProbe }
                  },
                  [_vm._v("发送申请")]
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }